import React, { useState, useEffect } from "react";
import "./style.css";

export default function GenerateLink() {
  const [guests, setGuests] = useState([]);
  const [owners, setOwners] = useState(null);
  const [guestName, setGuestName] = useState("");
  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
    let slug = "";
    if (searchParams.get("owners")) {
      slug = searchParams.get("owners");
      setOwners(slug);
    }

    return () => {};
  }, []);

  const updateGuestName = (e) => {
    setGuestName(e.target.value);
  };

  const addGuest = () => {
    setGuests([...guests, guestName]);
    setGuestName("");
  };

  const clearGuests = () => {
    setGuests([]);
  };

  const getLink = () => {
    const url = guests.join(",").replace(/ /g, "%20");
    let link = `https://inviteme.carvitec.com/invitations/${owners}?guests=${url}`;

    navigator.clipboard.writeText(link);
  };

  const removeGuest = (index) => {
    const filteredGuests = guests.filter((guest) => guest !== guests[index]);
    setGuests([...filteredGuests]);
  };

  return (
    <div className="generate__link__page">
      <div className="generate__link__form">
        <h1>Generate Link</h1>
        <div className="row generate__link__input__container">
          <label htmlFor="guest_name" className="guest__name__label">
            Guest Name:
          </label>
          <input
            type="text"
            className="guest__name__input"
            id="guest_name"
            name="guest_name"
            placeholder="Guest Name"
            value={guestName}
            onInput={updateGuestName}
          />
          <button
            className="guest__name__button"
            type="button"
            onClick={addGuest}
          >
            Add
          </button>
        </div>
        <button className="guest__name__button" type="button" onClick={getLink}>
          Copy Link
        </button>
        <button
          className="guest__name__clear__button"
          type="button"
          onClick={clearGuests}
        >
          Clear
        </button>
        {owners !== null && (
          <a
            className="guest__name__button guest__list__link"
            href={`https://invitationsbe.carvitec.com/attendingguests/${owners}`}
            target="_blank"
          >
            See Guest list
          </a>
        )}
      </div>
      <div className="guests__list">
        {guests.map((guest, index) => (
          <div className="row" key={index + guest}>
            <p>{guest}</p>
            <button
              className="guest__name__clear__button"
              type="button"
              onClick={() => removeGuest(index)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
